const HOST_MODE_MAP = {
  "oikosedu.app": "edu",
  "www.oikosedu.app": "edu",
  "oikoscampus.app": "campus",
  "www.oikoscampus.app": "campus",
};

const HOST_DEFAULT_PATH_MAP = {
  "oikosedu.app": "/edu",
  "www.oikosedu.app": "/edu",
  "oikoscampus.app": "/campus",
  "www.oikoscampus.app": "/campus",
};

const MODE_PATH_MAP = {
  edu: "/edu",
  pages: "/pages",
  campus: "/campus",
  devices: "/devices/admin",
  tables: "/tables",
  classroom: "/classroom",
};

export function normalizeHostname(hostname = "") {
  return String(hostname).toLowerCase().trim();
}

export function getForcedModeForHostname(hostname = "") {
  return HOST_MODE_MAP[normalizeHostname(hostname)] || null;
}

export function getDefaultPathForMode(mode = "home") {
  return MODE_PATH_MAP[mode] || "/edu";
}

export function getDefaultPathForHostname(hostname = "") {
  const normalizedHost = normalizeHostname(hostname);
  if (HOST_DEFAULT_PATH_MAP[normalizedHost]) return HOST_DEFAULT_PATH_MAP[normalizedHost];

  const forcedMode = getForcedModeForHostname(normalizedHost);
  return getDefaultPathForMode(forcedMode || "home");
}

export function resolveOriginalPath(explicitFrom, hostname = "", fallbackPath = "") {
  if (typeof explicitFrom === "string" && explicitFrom.trim()) {
    return explicitFrom;
  }

  if (typeof fallbackPath === "string" && fallbackPath.trim()) {
    return fallbackPath;
  }

  return getDefaultPathForHostname(hostname);
}
